export default "__VITE_ASSET__B_JNK04p__"